<div class="content-style-class">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="column">
      <h2 class="title-style">
        {{ dataService.res("Ubt-TreeList-StaffMembers") }}
      </h2>
    </div>
    <div
      *appCheckPermission="{
        context: PermissionContext.StaffMembers,
        action: Action.CREATE,
      }"
    >
      <div fxLayout="column" class="add-button-style">
        <abc-speed-dial-action
          icon="add"
          (onClick)="openStaffMemberDialog(false)"
        >
        </abc-speed-dial-action>
      </div>
    </div>
  </div>
  <div class="content-block">
    <div class="dx-card responsive-paddings card-radius">
      <abc-grid
        #staffMembersGrid
        class="grid-group-by-Style custome-export-style staffMember-grid grid-adaptive-mode"
        [id]="'staffMembers'"
        [dataSource]="staffMembers"
        [height]="'100%'"
        [width]="'100%'"
        [noDataText]="noDataText"
        [showBorders]="true"
        [showRowLines]="true"
        [showColumnLines]="true"
        [columns]="columnsHeader"
        (onCellPrepared)="onCellPrepared($event)"
        (onCellClick)="onCellClick($event)"
        (onExporting)="dataService.onExporting($event, exportFileName)"
        [columnHidingEnabled]="true"
        [wordWrapEnabled]="true"
        [columnAutoWidth]="false"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        [filterValue]="archiveFilter()"
        [filterPanel]="{
          visible: true,
          customizeText: customizeFilterPanelText
        }"
        >
        <div *dxTemplate="let data of 'archivedTemplate'">
          <abc-select-box
            class="dropDownStyle drop-down-filter"
            [dataSource]="filters"
            valueExpr="value"
            displayExpr="name"
            width="100%"
            [label]="dataService.res('Ubt-Staff-Members-User-Status')"
            [value]="selectedFilter()"
            (onValueChanged)="setArchivedVisibility($event)"
          >
          </abc-select-box>
        </div>
        <dxo-column-chooser [search]="{ enabled: true }" [enabled]="true">
        </dxo-column-chooser>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-filter-panel [visible]="true"></dxo-filter-panel>
        <dxo-export
          [enabled]="true"
          [allowExportSelectedData]="false"
          [formats]="['pdf', 'xlsx']"
        ></dxo-export>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-paging [enabled]="false"></dxo-paging>
        <dxo-search-panel
          [visible]="true"
          [highlightCaseSensitive]="true"
        ></dxo-search-panel>
      </abc-grid>
    </div>

    <abc-popup
      #staffMemberPopup
      id="staffMemberPopup"
      class="window-title-background"
      [showTitle]="true"
      (onHiding)="clearWindow()"
      [showCloseButton]="true"
      [width]="'90%'"
      [maxWidth]="700"
      [height]="'auto'"
    >
      <div class="dx-card responsive-paddings card-radius">
        <div fxLayout="column" fxFlexFill fxLayoutGap="10px">
          <abc-tab-panel
            #tabPanel
            class="tab-panel"
            [(selectedIndex)]="selectedIndex"
            [items]="tabItems"
            [itemTemplate]="'tabContent'"
            itemTitleTemplate="tabTitle"
            [deferRendering]="false"
          >
            <div *dxTemplate="let tab of 'tabTitle'">
              <div
                class="title-card"
                [class.active]="tab.index === selectedIndex"
                [class.inactive]="tab.index != selectedIndex"
              >
                {{ tab.title }}
              </div>
            </div>
            <div *dxTemplate="let tab of 'tabContent'">
              @switch (tab.index) {
                @case (0) {
                  <form action="post">
                    <abc-form
                      #form
                      id="form"
                      [(formData)]="staffMember"
                      [colCount]="1"
                    >
                      <dxi-item>
                        @if (!isEditing) {
                          <abc-text-box
                            [(value)]="newUserEmail"
                            [stylingMode]="'outlined'"
                            [width]="'100%'"
                            [label]="
                              dataService.res('Ubt-CreateStaffMembers-EMail')
                            "
                            [labelMode]="'floating'"
                          >
                            <dx-validator #emailValidator>
                              <dxi-validation-rule
                                type="email"
                                message="Please enter a valid email address"
                              ></dxi-validation-rule>
                              <dxi-validation-rule
                                type="required"
                                message="{{
                                  dataService.res('Ubt-validator-RequiredField')
                                }}"
                              ></dxi-validation-rule>
                            </dx-validator>
                          </abc-text-box>
                        }
                      </dxi-item>

                      <dxi-item
                        itemType="group"
                        [cssClass]="'form-buttons-container'"
                      >
                        @if (!isEditing) {
                          <dxi-item
                            itemType="button"
                            [cssClass]="'submit-button'"
                            [buttonOptions]="verifyEmailButtonOptions"
                          >
                          </dxi-item>
                        }
                      </dxi-item>
                      <dxi-item [isRequired]="true">
                        <abc-text-box
                          [(value)]="staffMember.FirstName"
                          (valueChange)="updateField('FirstName', $event)"
                          [stylingMode]="'outlined'"
                          [labelMode]="'floating'"
                          [label]="
                            dataService.res(
                              'Ubt-CreateStaffMembers-FirstName'
                            ) + '*'
                          "
                          [width]="'100%'"
                          [disabled]="isPersonExists"
                        >
                        </abc-text-box>
                        <dxi-validation-rule
                          type="required"
                          message="{{
                            dataService.res('Ubt-validator-RequiredField')
                          }}"
                        ></dxi-validation-rule>
                      </dxi-item>
                      <dxi-item [isRequired]="true">
                        <abc-text-box
                          [(value)]="staffMember.LastName"
                          mode="Email"
                          [stylingMode]="'outlined'"
                          [width]="'100%'"
                          [label]="
                            dataService.res('Ubt-CreateStaffMembers-LastName') +
                            '*'
                          "
                          [labelMode]="'floating'"
                          (valueChange)="updateField('LastName', $event)"
                          [disabled]="isPersonExists"
                        >
                        </abc-text-box>
                        <dxi-validation-rule
                          type="required"
                          message="{{
                            dataService.res('Ubt-validator-RequiredField')
                          }}"
                        ></dxi-validation-rule>
                      </dxi-item>
                      <dxi-item [isRequired]="true">
                        <abc-text-box
                          [(value)]="staffMember.EMail"
                          (valueChange)="updateField('EMail', $event)"
                          [stylingMode]="'outlined'"
                          [width]="'100%'"
                          [label]="
                            dataService.res('Ubt-CreateStaffMembers-EMail') +
                            '*'
                          "
                          [labelMode]="'floating'"
                          [disabled]="!isEditing"
                        >
                          <dx-validator>
                            <dxi-validation-rule
                              type="email"
                              message="Please enter a valid email address"
                            ></dxi-validation-rule>
                            <dxi-validation-rule
                              type="required"
                              message="{{
                                dataService.res('Ubt-validator-RequiredField')
                              }}"
                            ></dxi-validation-rule>
                          </dx-validator>
                        </abc-text-box>
                      </dxi-item>
                      <dxi-item [isRequired]="true">
                        <abc-select-box
                          class="drop-down-style"
                          valueExpr="Value"
                          [displayExpr]="'Value'"
                          [label]="dataService.res('Ubt-TreeList-Roles') + '*'"
                          [labelMode]="'floating'"
                          [stylingMode]="'outlined'"
                          [(value)]="staffMember.Function"
                          (valueChange)="updateField('Function', $event)"
                          [dataSource]="availableRoles"
                          [disabled]="isPersonExists"
                        >
                        </abc-select-box>
                        <dxi-validation-rule
                          type="required"
                          message="{{
                            dataService.res('Ubt-validator-RequiredField')
                          }}"
                        ></dxi-validation-rule>
                      </dxi-item>
                      <dxi-item [isRequired]="false">
                        <abc-text-box
                          [(value)]="staffMember.Login"
                          (valueChange)="updateField('Login', $event)"
                          [stylingMode]="'outlined'"
                          [labelMode]="'floating'"
                          [label]="
                            dataService.res('Ubt-StaffMembers-LoginName')
                          "
                          [width]="'100%'"
                          [disabled]="isPersonExists"
                        >
                        </abc-text-box>
                        <dxi-validation-rule
                          type="required"
                          message="{{
                            dataService.res('Ubt-validator-RequiredField')
                          }}"
                        ></dxi-validation-rule>
                      </dxi-item>
                      @if (!isSuperAdmin) {
                        <dxi-item [isRequired]="true" class="flex-group">
                          <abc-select-box
                            #projectRoleSelectBox
                            class="drop-down-style"
                            valueExpr="Value"
                            [displayExpr]="'Value'"
                            [label]="
                              dataService.res('Ubt-StaffMembers-Project-Role')
                            "
                            [labelMode]="'floating'"
                            [stylingMode]="'outlined'"
                            [(value)]="staffMemberPosition.Position"
                            (valueChange)="updateField('Position', $event)"
                            [dataSource]="availablePosition"
                            [disabled]="isAddressPersonExists && isPersonExists"
                            [class.focused]="!isAddressPersonExists"
                          >
                          </abc-select-box>
                          <dxi-validation-rule
                            type="required"
                            message="{{
                              dataService.res('Ubt-validator-RequiredField')
                            }}"
                          ></dxi-validation-rule>
                          @if (!isAddressPersonExists && !isEditing) {
                            <i
                              class="dx-icon dx-icon-info info-icon"
                              title="You must fill this field"
                            ></i>
                          }
                        </dxi-item>
                      }

                      <dxi-item class="file-uploader-container">
                        <div class="upload-section">
                          <img
                            [src]="
                              staffMemeberImage
                                ? staffMemeberImage
                                : 'assets/images/Avatar.svg'
                            "
                            alt="Staff Member Picture"
                            class="staff-member-picture"
                          />
                          <dx-file-uploader
                            #fileUpload
                            selectButtonText="{{
                              dataService.res('Ubt-StaffMember-Upload-Picture')
                            }}"
                            class="buttons-container"
                            labelText=""
                            accept="image/*"
                            uploadMode="useForm"
                            [allowCanceling]="true"
                            (onValueChanged)="
                              onFileUpload($event, uploadDocument)
                            "
                            [disabled]="isPersonExists"
                          >
                          </dx-file-uploader>
                        </div>
                        @if (
                          staffMember.Status === pickListStatus.NEW ||
                          staffMember.Status === pickListStatus.INVITED
                        ) {
                          <abc-button
                            (click)="sendEmailInvitation()"
                            width="210px"
                            class="send-email-button"
                            icon="message"
                            [text]="
                              dataService.res(
                                'Ubt-CreateStaffMembers-Send-Email-Invitation'
                              )
                            "
                          ></abc-button>
                        }
                      </dxi-item>

                      <dxi-item
                        itemType="group"
                        [cssClass]="'form-buttons-container'"
                      >
                        <abc-button
                          class="submit-button"
                          [text]="dataService.res('Ubt-Form-' + submitText)"
                          type="submit"
                          [disabled]="!canSave"
                          (click)="persistStaffMember()"
                        ></abc-button>
                        <abc-button
                          class="cancel-button"
                          [text]="
                            this.dataService.res('Ubt-CreateMeasure-Cancel')
                          "
                          type="submit"
                          (click)="clearWindow()"
                        ></abc-button>
                      </dxi-item>
                    </abc-form>
                  </form>
                }
                @case (1) {
                  <ubt-geods-company-role
                    (popupClosed)="clearWindow()"
                  ></ubt-geods-company-role>
                }
              }
            </div>
          </abc-tab-panel>
        </div>
      </div>
    </abc-popup>

    <abc-popup
      #confirmDeletePopup
      [width]="'90%'"
      [maxWidth]="700"
      fxLayout="column"
      fxLayoutAlign="center center"
      [height]="'auto'"
      [title]="dataService.res('Ubt-MeasureList-Confirm-Delete')"
      [showCloseButton]="true"
    >
      <div
        class="dx-card popup-card-paddings card-radius"
        fxLayout="column"
        fxLayoutAlign="center center"
        fxLayoutGap="20px"
      >
        <div
          fxLayout="column"
          fxLayoutAlign="center center"
          fxLayoutGap="20px"
          class="text-center"
        >
          {{ restoreOrDeleteText() }}
        </div>
        <dxi-item
          itemType="group"
          fxLayout="row"
          fxLayoutAlign="center end"
          fxLayoutGap="20px"
        >
          <dx-button
            class="submit-button"
            [text]="dataService.res('Ubt-MeasureList-Yes')"
            (onClick)="archiveOrRestoreStaffMember()"
          >
          </dx-button>
          <dx-button
            class="cancel-button"
            [text]="dataService.res('Ubt-MeasureList-No')"
            (onClick)="abortDelete()"
          >
          </dx-button>
        </dxi-item>
      </div>
    </abc-popup>
  </div>
</div>

<abc-context-menu
  #contextMenu
  id="contextMenu"
  class="abc-context-menu"
  showEvent="abcclick"
  [items]="contextMenuItems"
  [position]="{ my: 'top right', at: 'bottom right' }"
>
</abc-context-menu>
